export default {
	TITLE: 'Company policy',
	ACCEPT: 'Accept',
	DECLINE: 'Decline',
};
